import { gsap } from "gsap";
const id = "backdrop";

$("body").append(
  $(`
<div id="${id}"></div>
<style>
  #${id} {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    opacity: 0;
    visibility: hidden;
    background-color: rgba(15,15,15, 0.5);
    transition: opacity 0.25s, visibility 0.25s;
    z-index: 20;
  }
</style>
`)
);

const showBackdrop = function () {
  gsap.to(`#${id}`, { autoAlpha: 1, duration: 0.1 });
};

const hideBackdrop = function () {
  gsap.to(`#${id}`, { autoAlpha: 0, duration: 0.1 });
};

$(`#${id}`).on("click", function () {
  const $openNewsletterPopup = $(".timed-popup__visible");
  if ($openNewsletterPopup.length > 0) {
    const $closeIcon = $openNewsletterPopup.find(
      ".newsletter-popup__close-icon"
    );
    if ($closeIcon.length > 0) {
      $closeIcon.trigger("click");
    }
  }
  hideBackdrop();
});

export { showBackdrop, hideBackdrop };
